/* External Imports */
import React from 'react';

/* Internal Imports */
import { Box, Flex, Heading } from '@chakra-ui/react';
/* Components */
import config from '@config';
import SimpleButton from '@eternal/Components/Buttons/SimpleButton';
import SingleImage from '@eternal/Components/Card/SingleImage';
import SectionTitle from '@eternal/Components/Headings/SectionTitle';
import MidContainer from '@eternal/Components/Layout/MidContainer';

/**
 * Renders Render Simple Button Component
 *
 * @param {object} sectionContent - Data
 * @param {string} region - Region of Page
 * @param {string} lang - Language of Page
 * @returns {ReactElement} Render Simple Button Component
 */

const PreOrder = ({ sectionContent, region, lang }) => {
  const findElement = param =>
    sectionContent.find(el => el._modelApiKey === param);
  return (
    <Box
      pos="relative"
      background="#040404"
      _before={{
        content: "''",
        display: { base: 'none', '2xl': 'block' },
        width: { base: '50%', md: '20%', lg: '15%' },
        height: '100%',
        pos: 'absolute',
        backgroundImage: `${config.imgPath}/d/46272/1725352031-ssd-1.png`,
        backgroundSize: 'cover',
        backgroundRepeat: 'repeat',
        backgroundPosition: 'center',
        left: '0',
        top: '0',
        zIndex: 0,
        maxW: 167,
      }}
      _after={{
        content: "''",
        width: { base: '15%', md: '20%', lg: '10%', '2xl': '15%' },
        height: '100%',
        pos: 'absolute',
        backgroundImage: `${config.imgPath}/d/46272/1724839753-ssd-1-1.jpg`,
        backgroundSize: 'cover',
        backgroundRepeat: 'repeat',
        backgroundPosition: 'center',
        right: '0',
        top: '0',
        zIndex: 0,
        maxW: 167,
      }}
    >
      <MidContainer px={{ base: '20px', '2xl': '0' }}>
        <Flex
          pos="relative"
          zIndex={1}
          width={{ base: '95%', xl: '100%' }}
          h="auto"
          maxW={{ '2xl': '1580px' }}
          mx="auto"
          px="10px"
          flexWrap="wrap"
          alignItems="center"
          justifyContent="center"
          flexDir={{ base: 'column-reverse', md: 'row' }}
        >
          <Flex
            flexDir="column"
            alignSelf="center"
            alignItems={{ base: 'center', md: 'flex-start' }}
          >
            <SectionTitle
              noBorder
              titleObj={findElement('section_title')}
              textAlign={{ base: 'center', md: 'left' }}
              width="100%"
            />
            <Heading
              as="h3"
              display={{ base: 'block', md: 'none' }}
              fontFamily="FedraSansStd-book"
              color="#fff"
              fontSize="18px"
              mb="20px"
            >
              {findElement('section_title').additionalTextLine}
            </Heading>
            <SimpleButton style={findElement('simple_button')} />
          </Flex>
          <Box flex={1}>
            <SingleImage
              px={{ md: '16px' }}
              w={{ base: '100%', sm: 386, lg: 550, xl: 636, '2xl': 720 }}
              sectionContent={findElement('single_image')}
            />
          </Box>
        </Flex>
      </MidContainer>
    </Box>
  );
};

export default PreOrder;
